
(function () {
  'use strict';

  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function initSeriesHub(root) {
    if (!root || root.dataset.seriesHubInit === '1') return;
    root.dataset.seriesHubInit = '1';

    var tabs = root.querySelectorAll('[data-tab]');
    var search = root.querySelector('[data-search]');
    var clearBtn = root.querySelector('[data-search-clear]');
    var groups = root.querySelectorAll('[data-group]');
    var collections = root.querySelector('[data-collections]');
    var noRes = root.querySelector('[data-no-results]');
    var noResTerm = root.querySelector('[data-no-results-term]');
    var countEl = root.querySelector('[data-result-count]');

    var activeCat = 'all';
    var terms = [];
    var debounce;

    root.querySelectorAll('[data-item]').forEach(function (el) {
      el._hay = normalize(el.getAttribute('data-name'));
    });

 
    groups.forEach(function (group) {
      var titleEl = group.querySelector('[data-title]');
      group._title = titleEl ? normalize(titleEl.getAttribute('data-title')) : '';
    });

    function filter() {
      var total = 0;

      groups.forEach(function (group) {
        var items = group.querySelectorAll('[data-item]');
        var visible = 0;

        var groupMatches =
          terms.length > 0 &&
          group._title !== '' &&
          terms.every(function (t) {
            return group._title.indexOf(t) !== -1;
          });

        items.forEach(function (item) {
          var cat = item.getAttribute('data-category') || '';
          var catOk = activeCat === 'all' || cat === activeCat;

          var textOk =
            terms.length === 0 ||
            groupMatches ||
            terms.every(function (t) {
              return item._hay.indexOf(t) !== -1;
            });

          var ok = catOk && textOk;
          item.hidden = !ok;
          if (ok) visible++;
        });

        group.hidden = visible === 0;
        total += visible;
      });

      var searching = activeCat !== 'all' || terms.length > 0;

      if (collections) {
        collections.classList.toggle('is-searching', searching);
      }

      if (noRes) {
        noRes.hidden = total > 0;
        if (noResTerm && search) {
          noResTerm.textContent = '\u201C' + search.value.trim() + '\u201D';
        }
      }

      if (countEl) {
        countEl.hidden = terms.length === 0 || total === 0;
        countEl.textContent = total === 1 ? '1 result' : total + ' results';
      }

      if (clearBtn) clearBtn.hidden = !search || !search.value;
    }

    function setTab(slug) {
      if (typeof slug !== 'string' || slug === '') return;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === slug;
        t.classList.toggle('active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      activeCat = slug;
      filter();
    }

    function setQuery(value) {
      terms = normalize(value).split(' ').filter(Boolean);
      filter();
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.getAttribute('data-tab'));
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          setQuery(search.value);
        }, 120);
      });

      search.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && search.value) {
          e.preventDefault();
          search.value = '';
          setQuery('');
        }
      });

      search.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') e.preventDefault();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        search.value = '';
        setQuery('');
        search.focus();
      });
    }

    filter();

    root.seriesHub = {
      reveal: function (el) {
        if (!el) return;
        if (search) search.value = '';
        setQuery('');
        if (tabs.length) setTab(tabs[0].getAttribute('data-tab'));
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-series-hub]').forEach(initSeriesHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* ── Shopify theme editor ────────────────────────────── */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      var root = el.closest ? el.closest('[data-series-hub]') : null;
      if (!root) return;
      el.classList.add('is-selected');
      if (root.seriesHub) root.seriesHub.reveal(el);
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      e.target.classList.remove('is-selected');
    });
  }
})();
